//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import // XButton,
// XInput,
"vux";
import { mapState } from "vuex";

import { service, nativeApi } from "@/common/index";
import { fetch } from "@/page/index";
import SrmCommonUtils from "@/utils/SrmCommonUtils"

export default {
  data() {
    return {
      value: "",
      noteHeaderId: -1,
      headerInfo: {},
      noteLines: [],
      /** 刷新用变量 */
      pageIndex: 1,
      pageRows: 10,
      refreshing: true,
      finished: false,
      loading: false,
    };
  },
  components: {},
  computed: {
    ...mapState({
      userInfo: (state) => state.user.userInfo,
      languageCode: (state) => state.user.languageCode,
      dicCodes: (state) => state.user.dicCodes,
    }),
  },
  created() {
    this.noteHeaderId = this.$route.query.noteHeaderId;
    this.findNoteHeader();
    this.listNoteLines();
  },
  activated: function () {},
  methods: {
    findNoteHeader() {
      fetch.deliveryNoteHeader_findById({
          lan: this.languageCode,
          noteHeaderId: this.noteHeaderId,
        }).then((res) => {
            this.headerInfo = res.data;
        });
    },
    onLoad() {
      this.listNoteLines();
    },
    /**分页查询*/
    listNoteLines() {
      let _params = {
        lan: this.languageCode,
        pageIndex: this.pageIndex, //页数
        pageRows: this.pageRows,
        noteHeaderId: this.noteHeaderId,
      }
      fetch.deliveryNoteLine_listLineByPage(_params).then((res) => {
        //清楚最后多余的数据
        this.loading = false;
        if (this.pageIndex === 1 && res.data.length > 0) {
          res.data[0].extend = true
        }
        const curPageIndex = res.page.curIndex; //页数
        const curLength = (curPageIndex - 1) * this.pageRows; //index
        const lastLength = this.noteLines.length - curLength; //剩余长度
        this.noteLines.splice(curLength, lastLength);

        this.noteLines = this.noteLines.concat(res.data); //拼接数据
        if (this.noteLines.length < res.page.count) {
          this.pageIndex = res.page.nextIndex; //更新页数
        } else {
          //数据length不足row，没有更多数据，不继续往后加载
          this.finished = true;
        }
      }).catch((err) => {
        this.loading = false;
      });
    },
    /**展开物料行信息*/
    extendLineDetail(lineItem) {
      if (lineItem.extend === null || lineItem.extend === undefined || !!!lineItem.extend) {
        this.$set(lineItem, "extend", true)
      } else {
        this.$set(lineItem, "extend", false)
      }
    },
    /**取快码信息*/
    getLookupValuesMeaning(lookupType, lookupValue) {
      const _this = this
      return new SrmCommonUtils(_this).getLookupMeaning(lookupType, lookupValue)
    },
    /**格式化数字*/
    getFormatNumberValue(val) {
      return new SrmCommonUtils(this).getFormatNumberValue(val)
    }
  },
  watch: {},
  mounted() {},
};



// WEBPACK FOOTER //
// ./src/page/srm/delivery/delivery.vue